module.exports = __webpack_public_path__ + "img/chest_female_anterior.3e889ada.png";